import { Component, Input, QueryList, ContentChildren, ElementRef, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

declare let $: any;

export interface NmWizardSettings {
	steps: {
		title: string,
		nextCallback?: (e:any, info:any) => Promise<boolean>|boolean, // true: allow, false: disallow
		prevCallback?: (e:any, info:any) => Promise<boolean>|boolean, // true: allow, false: disallow
	}[],
	cancelUrl?: string,
}


@Component({
	selector: 'nm-wizard-step',
	template: `
		<div class="step-pane" [ngClass]="{'active': isActive}" [attr.data-step]="step">
			<ng-content></ng-content>
		</div>
	`
})
export class NmWizardStep {
	public isActive:boolean = false;
	public step: number;
}


@Component({
	selector: 'nm-wizard',
	templateUrl: './wizard.html'
})
export class NmWizard {
	@Input() settings: NmWizardSettings;
	@Input() cancelText = 'Cancel';
	@Input() prevText = 'Prev';
	@Input() finishText = 'Finish';
	@Input() nextText = 'Next';
	@ContentChildren(NmWizardStep) steps: QueryList<NmWizardStep>;
	@Output() onFinish = new EventEmitter();
	public isLastStep: boolean = false;

	public constructor(
		private elem: ElementRef
	) {}

	public ngAfterContentInit() {
		// set the first step-pane to active by default
		this.steps.first.isActive = true;
		this.steps.forEach((v, i) => {
			v.step = i+1;
		});
	}

	private wizardObj: any;
	private _isNavigating: boolean = false;
	public ngAfterViewInit() {
		let self = this;

		// init wizard only in THIS scope
		self.wizardObj = $(self.elem.nativeElement).find('#fuelux-wizard-container');

		self.wizardObj.ace_wizard()
		.on('actionclicked.fu.wizard', function(e, info) {

			let step = info.step - 1;

			if(self._isNavigating) {
				self._isNavigating = false;
				return true;
			}

			// if prevCallback is set
			if( 
				info.direction == 'previous' &&
				self.settings.steps[step].prevCallback &&
				typeof self.settings.steps[step].prevCallback == 'function'
			) {
				let pass = self.settings.steps[step].prevCallback(e, info);

				// Promise<boolean>
				if(pass instanceof Promise) {
					pass.then(_pass => {
						if(_pass) {
							self._isNavigating = true;
							self.previous();
						}
					});
					return false;
				}
				// boolean
				else {
					return pass;
				}
			}

			// if nextCallback is set
			else if(
				info.direction == 'next' &&
				self.settings.steps[step].nextCallback
			) {
				let pass =  self.settings.steps[step].nextCallback(e, info);

				// Promise<boolean>
				if(pass instanceof Promise) {
					pass.then(_pass => {
						if(_pass) {
							self._isNavigating = true;
							self.next();
						}
					});
					return false;
				}
				// boolean
				else {
					return pass;
				}
			}

			// default allow to next step
			else {
				return true;
			}

		})
		.on('finished.fu.wizard', function() {
			self.onFinish.emit();
		})
		.on('changed.fu.wizard', function(event, data) {
			self.isLastStep = data.step == self.steps.length;
		});
	}

	// nav next
	public next():void {
		this.wizardObj.wizard('next');
	}

	// nav previous
	public previous():void {
		this.wizardObj.wizard('previous');
	}
}


// WEBPACK FOOTER //
// ./src/widgets/wizard/wizard.ts